import { initializeApp } from "firebase/app";
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytes,
  uploadBytesResumable,
} from "firebase/storage";
import { random } from "lodash";
import moment from "moment";
import { BASE_PATH_FIREBASE, FIREBASE_CONFIG } from "./constants";
import firebase from "./firebase";

const storage = getStorage(firebase);

const baseUpload = async (path, file, loadingCb) => {
  try {
    let storageRef = ref(storage, path);
    const url = await new Promise((res, reject) => {
      const data = uploadBytesResumable(storageRef, file);
      data.on(
        "state_changed",
        (snapshot) => {
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          loadingCb?.(Math.round(progress));
        },
        (err) => reject(err),
        async () => {
          const url = await getDownloadURL(data.snapshot.ref);
          res(url);
        }
      );
    });
    return url;
  } catch (error) {
    return null;
  }
};

export const uploadCVCandidate = async (file, fileName) => {
  const path = "candidate-career/cv/";
  const url = await baseUpload(path + fileName, file);
  return url;
};

export const uploadImageCandidate = async (file, fileName) => {
  const path = "candidate-career/profile/";
  const url = await baseUpload(path + fileName, file);
  return url;
};

export const uploadCourseCandidate = async (file, fileName) => {
  const path = "candidate-career/course/";
  const url = await baseUpload(path + fileName, file);
  return url;
};

export const uploadResultDocument = async (file, filename) => {
  const path = "Admin-Career/result-document/";
  const url = await baseUpload(path + filename, file);
  return url;
};

export const uploadMediaInformation = async (file, filename) => {
  const path = "Admin-Career/media/";
  const url = await baseUpload(path + filename, file);
  return url;
};

// export const uploadMCUDoc = async (file, filename) => {
//   const path = "Admin-Career/MCU/"
//   const url = await baseUpload(path + filename, + ".docx", file)
//   return url
// }

export const uploadMCUDoc = async (file, filename, pathname) => {
  const path = "Admin-Career/MCU/" + pathname + "/";
  const url = await baseUpload(path + filename + ".docx", file);
  return url;
};

export const uploadTestDoc = async (file, filename) => {
  const path = "Admin-Career/Test/";
  const url = await baseUpload(path + filename, file);
  return url;
};

export const URLtoFile = async (url) => {
  const res = await fetch(url);
  const blob = await res.blob();

  const mime = blob.type;
  const ext = mime.slice(mime.lastIndexOf("/") + 1, mime.length);

  const file = new File([blob], `filename.${ext}`, {
    type: mime,
  });

  return file;
  // console.log(file);
};

// New helper firebase

export const firebaseConf = initializeApp(FIREBASE_CONFIG);

export const fireStorage = getStorage(firebaseConf);

// const imgCache = new Map();

export const uploadFile = async (path, file) => {
  try {
    // if (file?.name && imgCache.has(file.name)) {
    //   return imgCache.get(file.name);
    // }
    const pathRef = ref(fireStorage, path);
    const data = await uploadBytes(pathRef, file);
    const url = await getDownloadURL(data.ref);
    // if (url && file?.name) {
    //   imgCache.set(file.name, url);
    // }
    return url;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

const basePath = BASE_PATH_FIREBASE;

export const uploadImageEmployee = (file, fileName) => {
  return uploadFile(
    `${basePath}/testimoni/attachmentTestimoni${moment().format(
      "YYMMDDHHmmss"
    )}_${random(100, 999, false)}_${fileName}`,
    // )}_${random(100, 999, false)}_${file.name}`,
    file
  );
};
